module.exports = "../images/icons/upload.svg";